import * as React from 'react';

import { SoundActiveScreenConfigurationContext, frameworkSoundActiveScreen } from './soundActiveScreenConfiguration';

const withSoundActiveScreenConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <SoundActiveScreenConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkSoundActiveScreen} />
                );
            }}
        </SoundActiveScreenConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withSoundActiveScreenConfiguration;